import {reactive} from "vue";
import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";

class ClienteEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerClienteGravado = reactive({value: {clienteId: ''}})
    listenerClienteAlterado = reactive({value: {clienteId: ''}})

    listenerItemClienteGravado = reactive({value: {itemClienteId: ''}})
    listenerItemClienteAlterado = reactive({value: {itemClienteId: ''}})

    emitClienteGravado(clienteId: string) {
        this.listenerClienteGravado.value = {clienteId: clienteId}
    }

    emitClienteAlterado(clienteId: string) {
        this.listenerClienteAlterado.value = {clienteId: clienteId}
    }

    emitItemClienteGravado(itemClienteId: string) {
        this.listenerItemClienteGravado.value = {itemClienteId: itemClienteId}
    }

    emitItemClienteAlterado(itemClienteId: string) {
        this.listenerItemClienteAlterado.value = {itemClienteId: itemClienteId}
    }


}

export default ClienteEvents;